import React, { useRef } from "react";
import { animated, config, useChain, useTransition } from "react-spring";
import {Flex} from "../ui";
import {Btn} from "./../UI-Components/Btn";
import {ContModal} from "./styles";
import { ExclamationCircleOutline } from '@ant-design/icons';
import AntdIcon from '@ant-design/icons-react';

const Modal = ({open,close,tipo,message,actions=[],customMessage=false,children, closeBtn = true}) => {

    const ModalRef = useRef();
    const contModal = useRef();

  const transitions = useTransition(open, null, {
    from: {
      position: "fixed",
      top: "0",
      left: "0",
      zIndex: "999",
      width: "100%",
      height: "100%",
      overflow: "hidden",
      opacity: 0,
    },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    ref: contModal,
  });

  const modal = useTransition(open, null, {
    from: {
      transform: "scale(0) rotateX(45deg) ",
      opacity: 0,
    },
    enter: { opacity: 1, transform: "scale(1) rotateX(0deg)" },
    leave: { opacity: 0, transform: "scale(0.8) rotateX(-45deg)" },
    ref: ModalRef,
    config: config.stiff,
  });

  useChain(open ? [contModal, ModalRef] : [ModalRef, contModal], [0, 0.3,]);

  const alert = {
    alert_danger:
      "https://multimedia.epayco.co/dashboard/recaudo/proyecto/imagenes/alert-danger.png",
    alert_info:
      "https://multimedia.epayco.co/dashboard/recaudo/proyecto/imagenes/alert-info.png",
    alert_warning:
      "https://multimedia.epayco.co/dashboard/recaudo/proyecto/imagenes/alert-warning.png",
  };

  return transitions.map(
    ({ item, key, props }) =>
      item &&
        <animated.div key={key} style={props}>
          <ContModal tipo={tipo}>
            {modal.map(
              ({ item, key, props }) =>
                item && (
                  <animated.div className="mimodal" key={key} style={props}>
                    {closeBtn && <button className={"close ro"} onClick={close}>
                      <img
                          src="https://multimedia.epayco.co/dashboard/recaudo/proyecto/imagenes/closem.png"
                          alt=""
                          className={"col-12 px-0"}
                      />
                    </button> }
                    {children ?
                        children :
                        <>
                          <div className="col-12 text-center">
                            <div className="icono">
                              <img src={alert[`alert_${tipo}`]} alt="" />
                            </div>
                            {customMessage ? customMessage : <h3>{message}</h3>}
                          </div>
                          <div className="wc f01 pt-3">
                            {actions.map((ele, index) => (
                                <Flex
                                    className={"p-2"}
                                    elastic={"1 0 200px"}
                                    key={index}
                                >
                                  <Btn
                                      id={ele.id || ""}
                                      bg={ele.tipo}
                                      onClick={ele.onClicK}
                                      disabled={ele.disabled}
                                      loading={ele.loading || false}
                                  >
                                    {ele.text}
                                  </Btn>
                                </Flex>
                            ))}
                          </div>
                        </>
                    }
                  </animated.div>
                )
            )}
          </ContModal>
        </animated.div>

  );
};

const Modal2 = ({open,close,tipo,message, message2,customMessage=false,children, Logo = false, IconoClass = false, ModalClass = false}) => {

  const ModalRef = useRef();
  const contModal = useRef();

const transitions = useTransition(open, null, {
  from: {
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: "999",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    opacity: 0,
  },
  enter: { opacity: 1 },
  leave: { opacity: 0 },
  ref: contModal,
});

const modal = useTransition(open, null, {
  from: {
    transform: "scale(0) rotateX(45deg) ",
    opacity: 0,
  },
  enter: { opacity: 1, transform: "scale(1) rotateX(0deg)" },
  leave: { opacity: 0, transform: "scale(0.8) rotateX(-45deg)" },
  ref: ModalRef,
  config: config.stiff,
});

useChain(open ? [contModal, ModalRef] : [ModalRef, contModal], [0, 0.3,]);

return transitions.map(
  ({ item, key, props }) =>
    item &&
      <animated.div key={key} style={props}>
        <ContModal tipo={tipo}>
          {modal.map(
            ({ item, key, props }) =>
              item && (
                <animated.div className={ModalClass ? ModalClass : "mimodal-modal2"} key={key} style={props}>

                  {children ?
                      children :
                      <>
                        <div className="col-12 text-center">
                          <div className={IconoClass ? IconoClass : "icono"}>
                            {Logo ? 
                            
                            <img 
                              src={Logo}
                              alt="" width={"235px"} height={"325px"} className={"mr-2"}
                              />
                            :
                            <AntdIcon 
                              style={{ 
                                  color: '#FFD100',
                                  fontSize: '50px',
                                  width: '100%',
                                  textAlign: 'center',
                                  margin: '20px 0px'
                              }} 
                              type={ExclamationCircleOutline}/>
                            }
                          </div>
                          {customMessage ? customMessage : <div className="message-modal2 mb-4">{message}</div>}
                          {message2 && message2 != "" && <div className="message2-modal2 mb-1">{message2}</div>}
                        </div>
                      </>
                  }
                </animated.div>
              )
          )}
        </ContModal>
      </animated.div>

);
};

export { Modal, Modal2 };
